const Features = {
  // List of features. For example:
  // SOME_FEATURE_NAME: "1234-whatever-it-is-called"
  PILLAR_FILTER: "10073-pillar-filter",
  ARTICLES: "233-gloji-articles",
  CONFIGURABLE_PROFILE_BUILDER: "20407-profile-builder",
  MULTIPLE_JOURNEYS: "21363-multiple-journeys",
  MULTIPLE_MY_PATH: "20798-multi-my-path",
  TRACK_SMOKE_FREE: "8139-track-smoke-free-days",
};

export default Features;
